import { useFormik } from "formik";
import { get, isEmpty } from "lodash";
import { useTranslation } from "react-i18next";
import { NAME_SPACES } from "shared/locales/constants";
import { bindInputProps } from "utils/helpers/input";
import carteVitaleIcon from "../Assets/icons/carte_vitale.png";
import ActionButtons from "../Components/ActionButtons";
import DataProtection from "../Components/DataProtection";
import Header from "../Components/Header";
import InfoBox from "../Components/InfoBox";
import Input from "../Components/Input";
import Layout from "../Components/Layout";
import validation from "./validation";

function View({ contact, onNext, onBack }) {
  const { t } = useTranslation(NAME_SPACES.PUBLIC.ACORIS);
  const translate = t("SOCIAL_SECURITY_NUMBER", { returnObjects: true });

  const { submitForm, values, setFieldValue, ...formProps } = useFormik({
    initialValues: {
      socialSecurityNumber: get(contact, "socialSecurityNumber", ""),
      // Needed by validateNIR to match NIR year/month (+ gender) to the adherent
      user: {
        birthDate: get(contact, "user.birthDate"),
        gender: get(contact, "user.gender"),
      },
      fields: {
        ...get(contact, "fields", {}),
        teletransmission: get(contact, "fields.teletransmission", true),
      },
    },
    onSubmit: onNext,
    enableReinitialize: true,
    validationSchema: validation(
      t(`${NAME_SPACES.ERRORS}:VALIDATIONS`, { returnObjects: true }),
    ),
  });

  const teletransmissionEnabled = get(values, "fields.teletransmission", true);

  return (
    <Layout>
      <Header
        title={translate?.HEADER?.TITLE}
        highlight={translate?.HEADER?.HIGHLIGHT}
        subtitle={translate?.HEADER?.SUBTITLE}
      />
      <div className="acoris-form acoris-social-security">
        <div className="acoris-form__container acoris-social-security__container">
          <div className="acoris-social-security__content">
            <div className="acoris-social-security__fields">
              <Input
                placeholder={
                  translate?.FORM?.PLACEHOLDER || "1 85 05 78 006 084 36"
                }
                label={translate?.FORM?.LABEL || "N° de Sécurité sociale"}
                trim={true}
                {...bindInputProps({
                  name: "socialSecurityNumber",
                  values,
                  ...formProps,
                })}
                onChange={({ target: { value } }) => {
                  setFieldValue(
                    "socialSecurityNumber",
                    value.replace(/\s+/g, ""),
                  );
                }}
              />
              <Input
                type="checkbox"
                variant="round"
                label={
                  translate?.OPT_OUT_TELETRANSMISSION ||
                  "Je ne souhaite pas de télétransmission automatique avec le régime obligatoire (CPAM, MSA…)."
                }
                checked={!teletransmissionEnabled}
                {...bindInputProps({
                  name: "fields.teletransmission",
                  values,
                  ...formProps,
                })}
                onChange={(checked) => {
                  setFieldValue("fields.teletransmission", !checked);
                }}
              />
            </div>
            <InfoBox
              className="acoris-form__info-banner acoris-social-security__info"
              icon={carteVitaleIcon}
              variant="info"
              text={
                translate?.INFOBOX?.TEXT ||
                "Votre numéro de Sécurité sociale se trouve sur votre <strong>carte vitale</strong> ou votre <strong>attestation de droit</strong>. Cette information est strictement confidentielle et utilisée uniquement pour gérer votre contrat."
              }
            />
          </div>
          <ActionButtons
            disabled={!isEmpty(formProps.errors)}
            onNext={submitForm}
            onBack={onBack}
            nextText={translate?.BUTTON?.CONTINUE || "Continuer"}
            backText={translate?.BUTTON?.BACK || "Retour"}
          />
        </div>
      </div>
    </Layout>
  );
}

export default View;
